import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ContributorRow from "../components/ContributorRow";
import CreateContributor from "./CreateContributor";
import { useTranslation } from 'react-i18next';
import "./GroupPageCards.css";

export default function ContributorList(props) {
  const { t } = useTranslation();
  const {
    groupId,
    groupName,
    contributors,
    renderGroup,
    settlements,
    netTotals,
    contributorIdDict,
    settlementType,
    setIsLoading,
    isSettled = false,
    settlementInteractionBlockedUntil = 0,
  } = props;
  const modalId = "create-contributor-modal";
  const [collapse, setCollapse] = useState(false);

  useEffect(() => {
    const collapseCard = document.getElementById("collapseCardContributor");
    var bsCollapseCard = new window.bootstrap.Collapse(collapseCard, {
      toggle: false,
    });

    collapse ? bsCollapseCard.hide() : bsCollapseCard.show();
  }, [collapse]);

  const createContributorModal = (
    <CreateContributor
      modalId={modalId}
      groupId={groupId}
      renderGroup={renderGroup}
      setIsLoading={setIsLoading}
    />
  );

  return (
    <>
    <div className="card shadow-sm as-card as-theme position-relative">
      <div
        className="card-header cursor-pointer d-flex justify-content-between align-items-center flex-wrap as-card-header"
        onClick={() => setCollapse(!collapse)}
      >
        <div className="as-card-header-title">
          <span className="as-icon-badge" aria-hidden="true">
            🐾
          </span>
          <strong>{t('participant.title')}</strong>
        </div>
        <i className={`${collapse ? "bi bi-chevron-down" : "bi bi-chevron-up"}`}></i>
      </div>
      <div className="collapse show" id="collapseCardContributor">
        <ul className="list-group list-group-flush as-row-list">
          {contributors.map((c) => {
            return (
              <li className="list-group-item" key={c.id}>
                <ContributorRow
                  groupId={groupId}
                  groupName={groupName}
                  contributor={c}
                  renderGroup={renderGroup}
                  settlements={settlements}
                  netTotals={netTotals}
                  contributorIdDict={contributorIdDict}
                  settlementType={settlementType}
                  setIsLoading = {setIsLoading}
                  isSettled={isSettled}
                  settlementInteractionBlockedUntil={settlementInteractionBlockedUntil}
                />
              </li>
            );
          })}
        </ul>
        <div className="card-body">
          <button
            id="create-contributor-fab"
            className={`btn btn-primary position-absolute top-100 end-0 translate-middle-y me-3 shadow round as-fab ${
              collapse ? "invisible" : "visible"
            }`}
            data-bs-toggle={isSettled ? undefined : "modal"}
            data-bs-target={isSettled ? undefined : `#${modalId}`}
            disabled={isSettled}
            aria-label={
              isSettled
                ? (t("group.settled") || "Settled")
                : (t("participant.create_participant") || "Create participant")
            }
            title={
              isSettled
                ? (t("group.settled") || "Settled")
                : (t("participant.create_participant") || "Create participant")
            }
          >
            <i className={isSettled ? "bi-lock-fill" : "bi-plus-lg"} />
          </button>
        </div>
      </div>
    </div>
    {typeof document !== "undefined" ? createPortal(createContributorModal, document.body) : createContributorModal}
    </>
  );
}
